import { render, staticRenderFns } from "./DetailHeaderButtons.vue?vue&type=template&id=26b030be&%23customActions=true&"
import script from "./DetailHeaderButtons.vue?vue&type=script&lang=js&"
export * from "./DetailHeaderButtons.vue?vue&type=script&lang=js&"
import style0 from "./DetailHeaderButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports